<div *ngIf="presentPage === profilePage" class="profile-text" id="profileTextDiv">
  <div class="profile-name-title" id="profileNameTitleDiv">{{profileNameValue}}</div>
  <h2 class="profile-name-text">{{profileName}}</h2>
</div>
<div *ngIf="!this.iposliteEnabled; else elseBlock">
<iposcen-content-live-preview [sidenav]="'LogoContentGroup'" *ngIf="!showDeviceWallPreview"></iposcen-content-live-preview>
</div>
<ng-template #elseBlock >
  <div class="store-logo" >
    <img class="store-logo-img" src="assets/images/store-logo-display-iposlite.png" alt="store-logo-display-iposlite">
    
  </div>
</ng-template>
<div class="logo">
<div class="store-logo-text">The Shoppers will find your <strong>Store Logo Content</strong> when clicking a devices's Logo</div>
</div>
<div *ngIf="false">
<div *ngIf="showOrHidePreview" id="showOrHidePreviewDiv" class="profile-storelogo-live_preview-wrapper">
  <!-- New Preview Starts-->
  <div class="profile-storelogo-evo-preview-wrapper">
    <div class="live_preview  profile-storelogo-evo-live_preview" id="livePreviewDiv">
      <!-- Preview container specifies size of preview window -->
      <div class="preview__container evo_preview__container" id="previewContainerDiv">
        <!-- top navigation starts-->
        <div class="top_nav" id="topNavDiv">
          <img src="assets/images/evo_preview_logo_top_nav.svg" alt="navbar" />
        </div>
        <!-- top navigation ends-->
        <!-- Preview Resizer maintains aspect ratio of preview to 16:9 -->
        <div class="preview__resizer evo_preview__resizer" id="previewresizerDiv">
          <!-- This wrapper encases all preview content -->
          <div class="preview__wrapper evo_preview__wrapper" id="previewWrapperDiv">
            <!-- Preview has 2 sections: Main Layout and Footer -->

            <!-- Main Layout: Contains Sidebar and Navbar, Tiles -->
            <div class="main_layout" id="mainLayoutDiv">
              <!-- Sidebar with fact-tags -->
              <div class="sidebar" id="sideBarDiv">
                <div class="fact_tags" id="factTagsDiv">
                  <img src="assets/images/evo_ftag_proc.png" alt="proc ftag" />
                  <img src="assets/images/evo_ftag_proc.png" alt="proc ftag" />
                  <img src="assets/images/evo_ftag_proc.png" alt="proc ftag" />
                  <img src="assets/images/evo_ftag_proc.png" alt="proc ftag" />
                  <img src="assets/images/ftags.png" alt="ftags" />
                  <img src="assets/images/ftags.png" alt="ftags" />
                  <img src="assets/images/ftags.png" alt="ftags" />
                  <img src="assets/images/ftags.png" alt="ftags" />
                  <img src="assets/images/ftags.png" alt="ftags" />
                  <img src="assets/images/ftags.png" alt="ftags" />
                </div>
              </div>

              <!-- Main section with top navbar and tiles -->
              <div class="tiles_section" id="tilesSectionDiv">
                <div class="tiles" id="tilesDiv">
                  <!-- Tile 1 -->
                  <div class="herotile" id="heroTileDiv">
                    <img class="herotile-default"
                      src="assets/images/evo_preview_herotile_vector.svg" alt="tile 1" />
                    <img class="herotile-default-line"
                      src="assets/images/evo_preview_herotile_vector_line.svg" alt="tile 1 line" />
                  </div>
                  <div class="small_tiles" id="smallTilesDiv">
                    <!-- Tile 2 -->
                    <div class="card" id="cardDiv">
                      <div class="card-body" id="cardBodyDiv">
                        <img src="assets/images/evo_preview_tiles_vector.svg" alt="tile 2" />
                      </div>
                    </div>

                    <!-- Tile 3 -->

                    <div class="card" id="cardDivTile3">
                      <div class="card-body" id="previewTilesVectorSvg">
                        <img src="assets/images/evo_preview_tiles_vector.svg" alt="tile 3" />
                      </div>
                    </div>

                    <!-- Tile 4 -->
                    <div class="card" id="cardDivTile4">
                      <div class="card-body" id="previewTilesVectorSvg">
                        <img src="assets/images/evo_preview_tiles_vector.svg" alt="tile 4" />
                      </div>
                    </div>

                    <!--Tile 5-->
                    <div class="card" id="cardDivTile">
                      <div class="card-body" id="previewTilesVectorSvg">
                        <img src="assets/images/evo_preview_tiles_vector.svg" alt="tile 5" />
                      </div>
                    </div>

                    <!--Tile 6-->
                    <div class="card" id="cardDivTile4">
                      <div class="card-body" id="previewTilesVectorSvg">
                        <img src="assets/images/evo_preview_tiles_vector.svg" alt="tile 4" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Main Layout ends here -->

            <!-- Footer -->
            <footer class="footer" id="footerDiv">
              <div class="retailer_logo" [ngStyle]="{'background-color':bgColor}"
                id="retailerLogoDiv">
                <img [src]="defaultLogoImage" alt="logo" />
              </div>
              <div class="inline_separator" id="inlineSeparatorDiv"></div>

              <div class="inline_separator" id="inlineSeparatorDiv"></div>
              <div class="processor" id="processorDiv">
                <img src="assets/images/fact-tag_3_common.png" alt="proc" />
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
    <!-- New Preview Ends-->
    <label class="preview-label logo-label"><span i18n="@@content-live-preview.new-logo-preview.logo-new-preview-txt">The placement of the <strong>Logo Content Group</strong> on the Intel® Evo™ platform and non-gaming devices with Intel® Core™ Ultra processors. Shoppers can access it by clicking on your store logo.</span></label>
  </div>
  <div class="profile-storelogo-non-evo-live_preview-wrapper">
  <div class="live_preview profile-storelogo-non-evo-live_preview" id="livePreviewDiv">
    <!-- Preview container specifies size of preview window -->
    <div class="preview__container" id="previewContainerDiv">
      <!-- Preview Resizer maintains aspect ratio of preview to 16:9 -->
      <div class="preview__resizer" id="previewresizerDiv">
        <div id="previewInnerContainer" class="non_live_preview__innercontainer">
        <!-- This wrapper encases all preview content -->
        <div class="preview__wrapper" id="previewWrapperDiv">
          <!-- Preview has 2 sections: Main Layout and Footer -->

          <!-- Main Layout: Contains Sidebar and Navbar, Tiles -->
          <div class="main_layout" id="mainLayoutDiv">
            <!-- Sidebar with fact-tags -->
            <div class="sidebar" id="sideBarDiv"
        >
              <div class="fact_tags" id="factTagsDiv">
                <img src="assets/images/ftag_proc.png" alt="proc ftag" />
                <img src="assets/images/ftags.png" alt="ftags" />
                <img src="assets/images/ftags.png" alt="ftags" />
                <img src="assets/images/ftags.png" alt="ftags" />
                <img src="assets/images/ftags.png" alt="ftags" />
                <img src="assets/images/ftags.png" alt="ftags" />
              </div>
              <img class="ftag_scroll" src="assets/images/ftag_scroll_btn.svg" alt="scroll" />
            </div>

            <!-- Main section with top navbar and tiles -->
            <div class="tiles_section" id="tilesSectionDiv">
              <div class="top_nav" id="topNavDiv">
                <img src="assets/images/preview_top_nav.svg" alt="navbar" />
              </div>
              <div class="tiles" id="tilesDiv">
                <!-- Tile 1 -->
                <div class="herotile" id="heroTileDiv">
                  <img src="assets/images/preview_herotile_vector.svg" alt="tile 1" />
                </div>
                <div class="small_tiles" id="smallTilesDiv" >
                  <!-- Tile 2 -->
                  <div class="card" id="cardDiv">
                    <div class="card-body" id="cardBodyDiv">
                      <img src="assets/images/preview_tiles_vector.svg" alt="tile 2" />
                    </div>
                    <div class="card-footer" id="cardFooterDiv">
                      <img src="assets/images/preview_tiles_caption.svg" alt="tile 2 caption" />
                    </div>
                  </div>

                  <!-- Tile 3 -->
                  <div class="card banner_tile_preview" id="cardBannerTilePreview">
                    <div class="card-body" id="previewCardBody">
                      <svg width="30.72%" height="23" viewBox="0 0 47 23" fill="#e9e9e9"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="4.20082" cy="4.20082" r="4.20082" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.747 19.4657H46.9998L30.6585 0.191406L18.5161 14.5132L21.2443 18.841L18.0421 15.0723L18.0359 15.0796L11.1747 6.98685L0.594727 19.4657H1.747Z" />
                        <rect x="0.594727" y="20.8223" width="46.4051" height="1.18987" />
                      </svg>
                    </div>
                    <div class="card-footer" id="previewCardFooterDiv">
                      <svg width="84" height="8" viewBox="0 0 84 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="3.5" width="70" height="2" rx="1" fill="#AEAEAE" stroke="#AEAEAE" />
                        <path d="M80 1L83 4.5L80 7.5" stroke="#AEAEAE" />
                      </svg>
                    </div>
                  </div>

                  <!-- Tile 4 -->
                  <div class="card" id="cardDivTile4">
                    <div class="card-body" id="previewTilesVectorSvg">
                      <img src="assets/images/preview_tiles_vector.svg" alt="tile 2" />
                    </div>
                    <div class="card-footer" id="previewTilesCaption">
                      <img src="assets/images/preview_tiles_caption.svg" alt="tile 2 caption" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Main Layout ends here -->

          <!-- Footer -->
          <footer class="footer" id="footerDiv">
            <div class="retailer_logo" [ngStyle]="{'background-color':bgColor}" id="retailerLogoDiv">
              <img [src]="defaultLogoImage" alt="logo" />
            </div>
            <div class="inline_separator" id="inlineSeparatorDiv"></div>
            <div class="price" id="priceDiv">
              <span class="deleted_text"><del>$2099.00</del></span> &nbsp;
              <span class="new_price">$1899.00</span>
            </div>
            <div class="inline_separator" id="inlineSeparatorDiv"></div>
            <div class="processor" id="processorDiv">
              <img src="assets/images/preview_footer_processor.svg" alt="proc" />
            </div>
            <div class="explore_pc" id="explorePcDiv">
              <!-- Segment text and icon -->
              <svg width="41" height="13" viewBox="0 0 41 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.58895 4.7172L5.41427 8.89189L4.21875 7.69637L4.98478 6.93034L5.41427 7.35982L8.82292 3.95117L9.58895 4.7172Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.4987 2.16732C4.10546 2.16732 2.16536 4.10742 2.16536 6.50065C2.16536 8.89389 4.10546 10.834 6.4987 10.834C8.89193 10.834 10.832 8.89389 10.832 6.50065C10.832 4.10742 8.89193 2.16732 6.4987 2.16732ZM1.08203 6.50065C1.08203 3.50911 3.50716 1.08398 6.4987 1.08398C9.49024 1.08398 11.9154 3.50911 11.9154 6.50065C11.9154 9.49219 9.49024 11.9173 6.4987 11.9173C3.50716 11.9173 1.08203 9.49219 1.08203 6.50065Z" />
                <rect x="3.25" y="6.72461" width="1.08333" height="1.08333" transform="rotate(-45 3.25 6.72461)"
                  fill="#00C7FD" />
                <line x1="18" y1="7" x2="40" y2="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
              <!-- Explore PC text and icon -->
              <svg width="41" height="15" viewBox="0 0 41 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="explore_pc_logouticon">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M37.171 9.98756C37.13 9.94671 37.0975 9.89817 37.0753 9.84474C37.0532 9.7913 37.0417 9.73402 37.0417 9.67617C37.0417 9.61832 37.0532 9.56104 37.0753 9.5076C37.0975 9.45417 37.13 9.40564 37.171 9.36478L39.4993 7.03728L37.171 4.70977C37.0884 4.62718 37.042 4.51517 37.042 4.39838C37.042 4.28159 37.0884 4.16958 37.171 4.08699C37.2535 4.0044 37.3656 3.95801 37.4824 3.95801C37.5991 3.95801 37.7112 4.0044 37.7937 4.08699L40.4326 6.72589C40.4736 6.76674 40.5061 6.81527 40.5283 6.86871C40.5504 6.92214 40.5618 6.97942 40.5618 7.03728C40.5618 7.09513 40.5504 7.15241 40.5283 7.20584C40.5061 7.25928 40.4736 7.30781 40.4326 7.34866L37.7937 9.98756C37.7529 10.0285 37.7044 10.061 37.6509 10.0832C37.5975 10.1054 37.5402 10.1168 37.4824 10.1168C37.4245 10.1168 37.3672 10.1054 37.3138 10.0832C37.2604 10.061 37.2118 10.0285 37.171 9.98756Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M30.885 7.03698C30.885 6.92034 30.9313 6.80847 31.0138 6.72599C31.0963 6.64351 31.2082 6.59717 31.3248 6.59717H39.2415C39.3582 6.59717 39.47 6.64351 39.5525 6.72599C39.635 6.80847 39.6813 6.92034 39.6813 7.03698C39.6813 7.15363 39.635 7.2655 39.5525 7.34798C39.47 7.43046 39.3582 7.4768 39.2415 7.4768H31.3248C31.2082 7.4768 31.0963 7.43046 31.0138 7.34798C30.9313 7.2655 30.885 7.15363 30.885 7.03698Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M28.6859 11.8752C28.336 11.8752 28.0004 11.7362 27.7529 11.4887C27.5055 11.2413 27.3665 10.9057 27.3665 10.5557V3.51867C27.3665 3.16873 27.5055 2.83312 27.7529 2.58568C28.0004 2.33823 28.336 2.19922 28.6859 2.19922H34.8433C35.1933 2.19922 35.5289 2.33823 35.7763 2.58568C36.0238 2.83312 36.1628 3.16873 36.1628 3.51867V4.83811C36.1628 4.95476 36.1164 5.06663 36.034 5.14911C35.9515 5.23159 35.8396 5.27793 35.723 5.27793C35.6063 5.27793 35.4944 5.23159 35.412 5.14911C35.3295 5.06663 35.2831 4.95476 35.2831 4.83811V3.51867C35.2831 3.40202 35.2368 3.29015 35.1543 3.20767C35.0718 3.12519 34.96 3.07885 34.8433 3.07885H28.6859C28.5693 3.07885 28.4574 3.12519 28.3749 3.20767C28.2924 3.29015 28.2461 3.40202 28.2461 3.51867V10.5557C28.2461 10.6724 28.2924 10.7842 28.3749 10.8667C28.4574 10.9492 28.5693 10.9955 28.6859 10.9955H34.8433C34.96 10.9955 35.0718 10.9492 35.1543 10.8667C35.2368 10.7842 35.2831 10.6724 35.2831 10.5557V9.23627C35.2831 9.11963 35.3295 9.00776 35.412 8.92528C35.4944 8.8428 35.6063 8.79646 35.723 8.79646C35.8396 8.79646 35.9515 8.8428 36.034 8.92528C36.1164 9.00776 36.1628 9.11963 36.1628 9.23627V10.5557C36.1628 10.9057 36.0238 11.2413 35.7763 11.4887C35.5289 11.7362 35.1933 11.8752 34.8433 11.8752H28.6859Z" />
                <line x1="1" y1="3" x2="22" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <line x1="4" y1="11" x2="22" y2="11" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </div>
          </footer>
        </div>
      </div>
      </div>
    </div>
  </div>
  <div class="preview-border-txt">
    <label>
      <span i18n="@@content-live-preview.old-logo-preview.logo-old-preview-txt">The placement of the Logo Content Group on devices with an Intel® Core™ processor (14th, 13th, 12th Gen).</span>
    </label>
  </div>
  </div>
</div>
</div>
<div *ngIf="showDeviceWallPreview">
  <div class="live_preview" id="livePreviewDiv">
    <div class="preview__container devicewallpaper" id="previewContainerDiv">
      <!-- Preview Resizer maintains aspect ratio of preview to 16:9 -->
      <div class="preview__resizer" id="previewresizerDiv">
        <!-- This wrapper encases all preview content -->
        <div class="preview__wrapper" id="previewWrapperDiv" [style.background-color]="dwpBgColor">
          <div class="items-div" *ngIf="isDwpRadioSelected">
            <img [src]="dwpImage" alt="Wallpaper Image" [height]="height" [width]="width"
              [ngClass]="{'defaultHWCls':defaultHW,'dwp-img':!defaultHW}" />
            <div *ngIf="fallBackImage" class="mt-2">Select or upload an image to see the preview</div>
          </div>
          <div class="items-div" *ngIf="isDwpWallUploaded && !isDwpRadioSelected">
            <img [src]="dwpImage" alt="Wallpaper Image" />
          </div>
        </div>
      </div>
      <div class="text-center"><label i18n="@@content-live-preview.device-wall-paper.preview-label"
          class="devicewall-preview-label" *ngIf="showDeviceWallPreview"><strong>Preview of device
            wallpaper.</strong></label></div>
    </div>
  </div>
</div>

<div id="iposcenLogoContentDiv">
  <iposcen-logo-content [setIposliteEnabled]="this.iposliteEnabled"></iposcen-logo-content>
</div>
